import { useEtapaRevisao } from "./use-etapa-revisao";
import { EtapaRevisaoView } from "./view-etapa-revisao";

export function EtapaRevisao() {
  const vm = useEtapaRevisao();

  return <EtapaRevisaoView {...vm} />;
}

export type * from "./types-etapa-revisao";
